import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ShopCardImage from "../../../components/ShopCardImage/ShopCardImage";
import { cardImage, cardSourceFromRow } from "../../../domain/shopImages";
import { useRecomendedShops } from "../../../hooks/useInfluencer";
import s from "./ShopEmpty.module.css";
import SubscribeForm from "./SubscribeForm.jsx";

function RecommendedTile({ shop }) {
  const source = cardSourceFromRow(shop);

  return (
    <Link to={`/${shop.route}`} className={s.card}>
      <ShopCardImage
        source={source}
        name={shop.name}
        width={144}
        height={192}
      />
      <div className={s.cardText}>
        <div className={s.cardName}>{shop.name}</div>
        <div className={s.cardLabel}>
          {cardImage(source).mainLabel ?? "Shop"}
        </div>
      </div>
    </Link>
  );
}

RecommendedTile.propTypes = {
  shop: PropTypes.shape({
    route: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

function Recommendations({ route }) {
  const { influencers, isLoading } = useRecomendedShops({ route });

  if (isLoading || !influencers || influencers.length === 0) return null;

  return (
    <div className={s.recommendations}>
      <h3 className={s.recommendationsHeading}>You might also like</h3>
      <div className={s.recommendationsList}>
        {influencers.slice(0, 6).map((shop) => (
          <RecommendedTile key={shop.route} shop={shop} />
        ))}
      </div>
    </div>
  );
}

Recommendations.propTypes = {
  route: PropTypes.string.isRequired,
};

export default function ShopEmpty({ influencerName, influencerId, route }) {
  return (
    <section className={s.root} aria-label="Empty shop">
      <div>
        <h2 className={s.heading}>
          {influencerName
            ? `${influencerName}'s shop has no items available right now`
            : "This shop has no items available right now"}
        </h2>
        <p className={s.subtext}>
          Check back soon — new products may be added at any time.
        </p>
      </div>

      <SubscribeForm influencerId={influencerId} />
      <Recommendations route={route} />
    </section>
  );
}

ShopEmpty.propTypes = {
  influencerName: PropTypes.string,
  influencerId: PropTypes.number.isRequired,
  route: PropTypes.string.isRequired,
};
